/*
 * Copyright (c) 2023.
 * @FileName: index
 * @FilePath: src/utils/request/interceptors/response-interceptor
 * @Description: 响应拦截
 * @Project: kerastase_2022_member-center_wx-mp_frontend
 * @Author: lunazhou
 * @Date: 2023/2/2 19:33
 * @LastEditors: lunazhou
 * @LastEditTime: 2023/2/2 19:33
 */

const responseInterceptor: Function[] = [];

export default responseInterceptor;
